import axios from "axios";
import { combinedUrls } from "../../URL/functions";
import { projectUrls } from "../../URL/ApplicationUrls";

export function useCreateProjectWithFtlRoutes() {
  return async function createProjectWithFtlRoute(selectedRoutes: number[]) {
    const response = await axios.post<number | undefined>(
      combinedUrls(projectUrls.base.apiUrl, "/AddProjectFromFtlRoutes"),
      selectedRoutes
    );
    if (!response.data) {
      throw new Error("Error: Create Project failed and ProjectId is undefined");
    }
    return { newProjectId: response.data };
  };
}
